import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { complianceService } from '../../../services/adminService';

interface AuditEvent {
  id: string;
  actor?: string;
  action?: string;
  resource?: string;
  created_at?: string;
  metadata?: Record<string, any>;
}

const AuditTrail: React.FC = () => {
  const [items, setItems] = useState<AuditEvent[]>([]);
  const [loading, setLoading] = useState(false);
  const [actor, setActor] = useState('');
  const [action, setAction] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const res = await complianceService.getAuditTrail({ actor: actor || undefined, action: action || undefined, limit: 50 });
      setItems(res || []);
    } catch (e: any) {
      toast.error(e?.message || 'Failed to load audit trail');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-medium">Audit Trail</h2>
        <div className="flex gap-2">
          <input value={actor} onChange={(e) => setActor(e.target.value)} placeholder="Actor" className="border rounded px-3 py-2" />
          <input value={action} onChange={(e) => setAction(e.target.value)} placeholder="Action" className="border rounded px-3 py-2" />
          <button onClick={load} className="px-3 py-2 text-sm rounded border">Apply</button>
        </div>
      </div>

      {loading ? (
        <div>Loading...</div>
      ) : (
        <div className="overflow-auto border rounded">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Time</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Actor</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Action</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Resource</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {items.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-4 py-6 text-center text-sm text-gray-500">No audit events</td>
                </tr>
              )}
              {items.map((it) => (
                <tr key={it.id}>
                  <td className="px-4 py-2 text-sm">{it.created_at ? new Date(it.created_at).toLocaleString() : '-'}</td>
                  <td className="px-4 py-2 text-sm">{it.actor || '-'}</td>
                  <td className="px-4 py-2 text-sm">{it.action || '-'}</td>
                  <td className="px-4 py-2 text-sm">{it.resource || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AuditTrail;
